import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({
  children,
  allowedTypes = [],
  permission,
  permissions = [],
  requireAllPermissions = false,
  fallbackPath = '/',
}) {
  const {
    isAuthenticated,
    loading,
    permissionsLoading,
    user,
    isFullAccess,
    hasAnyPermission,
    hasAllPermissions,
  } = useAuth();
  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>جاري التحميل...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (allowedTypes.length > 0 && !allowedTypes.includes(user?.type)) {
    return <Navigate to="/login" replace />;
  }
  if (permission || permissions.length > 0) {
    if (permissionsLoading) {
      return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>جاري التحقق من الصلاحيات...</div>;
    }
    if (!isFullAccess) {
      const required = permission ? [permission, ...permissions] : permissions;
      const allowed = requireAllPermissions
        ? hasAllPermissions(required)
        : required.length === 0
          ? true
          : hasAnyPermission(required);
      if (!allowed) return <Navigate to={fallbackPath} replace />;
    }
  }
  return children;
}
